<template>

    <div class="builder-header">
        <v-input size="sm" placeholder="Add a subject" :model="action.subject" @input="updateSubject($event)" />
    </div>

</template>

<style scoped lang="scss">

    @import "@sass/_variables.scss";

    .builder-header {
        background: #fff;
        border-bottom: 1px solid $color-rule;
        padding: 15px;
    }

</style>

<script>

export default {

    computed: {

        action() {
            return this.$store.getters['builder/action'];
        },

    },

    methods: {

        updateSubject(val) {
            let action = this.action;
            this.$set(action, 'subject', val);
            this.$store.commit('builder/setAction', action);
        },

    },

}

</script>